<template>
  <div>
    <b-row>
      <b-col md="12">
        <attendance-card :campusID="$store.state.userData.cId" />
      </b-col>
      <b-col md="12">
        <homework-card :campusID="$store.state.userData.cId" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from "bootstrap-vue";
import AttendanceCard from "@/views/dashboard/ecommerce/AttendanceCard.vue";
import HomeworkCard from "@/views/dashboard/ecommerce/HomeworkCard.vue";

export default {
  name: "principalDashboard",
  components: {
    BRow,
    BCol,
    AttendanceCard,
    HomeworkCard,
  },
  data() {
    return {
      rights: {},
    };
  },
  created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
    }
  },
};
</script>
<style></style>
